<template>
  <kullanici-ekle :value="value" @input="$emit('input', $event)" :duzenle="kullaniciDetay" />
</template>

<script>
import { mapState } from 'vuex';
import KullaniciEkle from "./KullaniciEkle.vue";
export default {
  name: "KullaniciDuzenle",
  props: {
      value: {
          type: Boolean,
          default: false,
          required: true,
      }
  },
  components: { KullaniciEkle },
  computed: {
      ...mapState({
          kullaniciDetay: state => state.Kullanicilar.KullaniciList.kullaniciDetay
      })
  }
};
</script>

<style>
</style>